import React, { useCallback, useEffect, useRef } from "react";
import { useDispatch, useSelector, RootStateOrAny } from "react-redux";
import { useHistory } from "react-router-dom";
import { SubmitHandler, FormHandles } from "@unform/core";
import { Form } from "@unform/web";
import * as Yup from "yup";
import { useTranslation } from "hooks";
import { translations } from "./translations";

import { CreateRtvState, CreateRtvActions } from "store/ducks/settings/rtv";
import {
  ListRegionalState,
  ListRegionalActions,
} from "store/ducks/settings/regional";

import { useValidation } from "hooks";

import * as S from "./styles";
import { MainContainer } from "components/shared";
import { Input, Select } from "components/shared/Form";

export const NewRTV: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const { handleFormErrors } = useValidation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { getTranslation } = useTranslation(translations);

  const { loading } = useSelector<RootStateOrAny, CreateRtvState>(
    (state) => state.createRtv,
  );
  const { loading: listRegionalLoading, data: listRegionalData } = useSelector<
    RootStateOrAny,
    ListRegionalState
  >((state) => state.listRegional);

  const onSuccess = useCallback(() => {
    history.push("/settings/rtv");
  }, [history]);

  const handleSubmit = useCallback<SubmitHandler>(
    async (data) => {
      try {
        formRef.current?.setErrors({});
        const schema = Yup.object().shape({
          general_regional_id: Yup.string().required(
            getTranslation("obrigatorio"),
          ),
          cod_rtv: Yup.string().required(getTranslation("obrigatorio")),
          rtv_gr: Yup.string().required(getTranslation("obrigatorio")),
        });
        await schema.validate(data, {
          abortEarly: false,
        });

        dispatch(CreateRtvActions.request(data, onSuccess));
      } catch (error) {
        handleFormErrors(error, formRef);
      }
    },
    [dispatch, getTranslation, handleFormErrors, onSuccess],
  );

  const getRegional = useCallback(() => {
    dispatch(ListRegionalActions.request({ all: true }));
  }, [dispatch]);

  useEffect(() => {
    getRegional();
  }, [getRegional]);

  return (
    <MainContainer>
      <S.PageHeader>
        <h1>
          <S.IconSetting />
          {getTranslation("configuracoes")}{" "}
          <span>{getTranslation("title")}</span>
        </h1>
        <S.ButtonMini btStyle="dark" onClick={() => history.goBack()}>
          <S.IconArrowLeft />
          {getTranslation("voltar")}
        </S.ButtonMini>
      </S.PageHeader>
      <S.PageContent>
        <Form ref={formRef} onSubmit={handleSubmit}>
          <S.BoxContainer>
            <S.FormRow>
              <Select
                name="general_regional_id"
                label={getTranslation("regional")}
                options={listRegionalData}
                isLoading={listRegionalLoading}
                isDisabled={listRegionalLoading}
                placeholder={getTranslation("selecione")}
              />
              <Input name="cod_rtv" label={getTranslation("rtv")} />
              <Input name="rtv_gr" label={getTranslation("rtv_gr")} />
            </S.FormRow>
          </S.BoxContainer>
          <S.FormFooter>
            <S.FormRow>
              <S.Button
                btStyle="cancel"
                type="button"
                onClick={() => history.goBack()}
              >
                {getTranslation("cancelar")}
              </S.Button>
              <S.Button type="submit">
                {loading ? <S.Loading /> : getTranslation("cadastrar")}
              </S.Button>
            </S.FormRow>
          </S.FormFooter>
        </Form>
      </S.PageContent>
    </MainContainer>
  );
};
